import BonusGameModal from './BonusGameModal';
export default BonusGameModal;
